module.exports = __webpack_public_path__ + "static/media/camera.6cc9e9fe.svg";